import { Injectable } from '@angular/core';
import { User } from '@angular/fire/auth';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})

export class AccessService {

    currentUser:any
    linkedUser:any
    userData:any
    contextId:any
    
    constructor(private dataService: DataService) {}

    checkUserAccess(user: User): Promise<{ hasAccess: boolean; isOnlyTracer: boolean }> {
        return new Promise((resolve, reject) => {
            this.dataService.getUserData(user.uid).subscribe({
            next: (data) => {
                this.userData = data;
                let roles: string[] = [];

                const activeContext = this.dataService.getLocalContextId();
                roles = (activeContext !== null && this.userData.rolesPerContext?.[activeContext]) || this.userData.roles || [];
                const hasAccess = roles.some(role =>
                    ['admin', 'workTaskManager', 'tracingSupervisor', 'tracer'].includes(role)
                );

                const isOnlyTracer = roles.length === 1 && roles[0] === 'tracer';

                resolve({ hasAccess, isOnlyTracer });
            },
            error: (err) => {
                console.error('Error checking user access:', err);
                reject(false); // or: reject({ hasAccess: false, isOnlyTracer: false });
            }
            });
        });
        }
}